<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Tichet de suport"></SketchBreadcrumb>
        <div class="padding-box">
            <b-overlay :show="ticketLoading" :opacity="opacity">
                <div class="white-box">
                    <div class="title-div mb-5">
                        <h3>
                            <router-link v-if="$route.fullPath.includes('m3-sketch')" to="/aplicatii/m3-sketch/tichete-suport" style="color: inherit;"><b-icon-arrow-left></b-icon-arrow-left></router-link>
                            <router-link v-else to="/tichete-suport" style="color: inherit;"><b-icon-arrow-left></b-icon-arrow-left></router-link>
                            {{ ticket.subject }}</h3>
                        <div>
                            <p class="ticket-opened" :class="getClassByStatus(ticket.status)">{{ getNameByStatus(ticket.status) }}</p>
                            <p style="font-size: 13px;">Problemă raportată pe {{ formatUtcDate(ticket.created, 'DD.MM.YYYY (HH:mm)') }}</p>
                        </div>
                    </div>
                    <div class="row ticket-box">
                        <div class="ticket-box-left col-md-8">
                            <div class="col-md-12">
                                <b-button class="toggle-reply" @click="replyVisible = !replyVisible">Răspunde tichet-ului</b-button>
                                <b-collapse v-model="replyVisible">
                                    <validation-observer ref="problemForm">
                                        <form class="row pt-2 mb-4" @submit="submit">
                                            <div class="col-md-12">
                                                <b-form-group
                                                    label="Mesaj"
                                                    label-for="message"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        name="mesaj"
                                                    >
                                                        <b-form-textarea
                                                            id="message"
                                                            v-model="form.message"
                                                            type="text"
                                                            name="message"
                                                            :state="errors.length > 0 ? false : null"
                                                            placeholder="Mesaj"
                                                            rows="5"
                                                        ></b-form-textarea>
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-12">
                                                <b-form-group
                                                    label="Fișier"
                                                    label-for="file"
                                                >
                                                    <b-form-file
                                                        ref="fileUploaded"
                                                        multiple
                                                        placeholder="Alege unul sau mai multe fișiere"
                                                        drop-placeholder="Trage aici fișierul"
                                                        browse-placeholder="Test"
                                                        @change="uploadFile"
                                                    ></b-form-file>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-button
                                                    type="submit"
                                                    class="background"
                                                    text="Trimite răspunsul"
                                                    classname="background"
                                                >Trimite răspunsul</b-button>
                                            </div>
                                        </form>
                                    </validation-observer>
                                </b-collapse>
                            </div>

                            <div class="ticket-content">
                                <div v-for="(ticketReply, key) in ticket.replies" :key="key" class="ticket-reply" :class="!ticketReply.can_be_edited ? 'ticket-agent' : ''">
                                    <div class="head">
                                        <div v-if="!ticketReply.can_be_edited" class="head-flex">
                                            <img :src="ticketReply.user.user_logo" :alt="ticketReply.user.name">
                                            <div>
                                                <p class="mb-0 bold-text">{{ ticketReply.user.name }}</p>
                                                <p>Echipa de asistență</p>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <p class="mb-0 bold-text">{{ userName }}</p>
                                            <p>Client Smis</p>
                                        </div>
                                        <p>{{ formatUtcDate(ticketReply.created, 'DD.MM.YYYY (HH:mm)') }}</p>
                                    </div>
                                    <div class="body">
                                        <div v-html="sanitize(ticketReply.comment)"></div>
                                    </div>
                                    <div v-if="ticketReply.files && ticketReply.files.length > 0" class="footer">
                                        <p>Fișiere atașate:</p>
                                        <a v-for="(file, keyFile) in ticketReply.files" :key="keyFile" :href="file.url" target="_blank" download
                                           class="text-purple-dark font-medium">{{ file.name }} &nbsp; <span v-if="keyFile !== ticketReply.files.length - 1">|</span></a>
                                    </div>
                                </div>
                                <div class="ticket-reply">
                                    <div class="head">
                                        <div>
                                            <p class="mb-0 bold-text">{{ userName }}</p>
                                            <p>Client Smis</p>
                                        </div>
                                        <p>{{ formatUtcDate(ticket.created, 'DD.MM.YYYY (HH:mm)') }}</p>
                                    </div>
                                    <div class="body">
                                        <div v-html="sanitize(ticket.comment)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ticket-sidebar col-md-4">
                            <ProblemaSidebar :sidebarData="sidebarData" @replyTicket="replyVisible = true" @closeTicket="closeTicket()"></ProblemaSidebar>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import ProblemaSidebar from './ProblemaSidebar'
    import { BIconArrowLeft, BCollapse, BButton, VBToggle, BFormGroup, BFormTextarea, BFormInput, BFormFile, BOverlay } from 'bootstrap-vue';
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import {formatUtcDate} from '@/helpers/helpers'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    /* import _ from "lodash";*/
    require('@/helpers/validations/validations')
    export default {
        components: {
            SketchBreadcrumb,
            ProblemaSidebar,
            BIconArrowLeft,
            BCollapse, BButton, BFormGroup, BFormTextarea, BFormInput, BFormFile, BOverlay,
            ValidationProvider, ValidationObserver
        },
        directives: {
            'b-toggle': VBToggle
        },
        data() {
            return {
                form: {
                    message: '',
                    file: []
                },
                userName: '',
                ticketLoading: false,
                opacity: 1,
                ticket: [],
                sidebarData: [],
                replyVisible: false
            }
        },
        mounted() {
            if(this.$store.getters['auth/user'] && this.$store.getters['auth/user'].name){
                this.userName = this.$store.getters['auth/user'].name
            }
            this.getSingleTicket()
        },
        methods: {
            sanitize(text){
                return this.$sanitize(text);
            },
            formatUtcDate,
            getNameByStatus(status) {
                if(status === 'opened') {
                    return 'Tichet deschis'
                } else if(status === 'client_replied') {
                    return 'Cu răspuns de la client'
                }else if(status === 'replied') {
                    return 'Tichet cu răspuns'
                }else if(status === 'closed') {
                    return 'Tichet închis'
                }
            },
            getClassByStatus(status) {
                if(status === 'opened') {
                    return 'opened-status'
                } else if(status === 'client_replied') {
                    return 'client-reply-status'
                }else if(status === 'replied') {
                    return 'agent-reply-status'
                }else if(status === 'closed') {
                    return 'closed-status'
                }
            },
            getSingleTicket() {
                this.ticketLoading = true
                axios.get(api.API_ENDPOINTS.ticketSingle + '/' + this.$route.params.id + '/poc-sketch/')
                    .then(response => {
                        this.ticket = response.data
                        this.sidebarData = {
                            id: response.data.id ? response.data.id : '',
                            subject: response.data.subject ? response.data.subject : '',
                            status: response.data.subject ? response.data.status : '',
                            department: response.data.department ? response.data.department : '',
                            created: response.data.created ? response.data.created : '',
                            lastAction: response.data.lastAction ? response.data.lastAction : '',
                        }
                        this.ticketLoading = false
                        this.opacity = 0.85
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
                    .catch( xhr => {
                        this.ticketLoading = false
                        console.log(xhr);
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
            },
            uploadFile(event) {
                this.form.file = [];
                event.target.files.forEach(file => {
                    this.form.file.push(file)
                })
            },
            submit(e) {
                e.preventDefault();
                this.$refs.problemForm.validate().then(error => {
                    if(!error){
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    }
                    else {
                        let ticketId = this.$route.params.id
                        let newComment = this.form.message
                        let formData = new FormData;
                        formData.append('comment', newComment);
                        formData.append('parent_id', ticketId);
                        if (this.form.file) {
                            this.form.file.forEach((file, index) => {
                                formData.append(`file[${index}]`, file, file.name)
                            })
                        }

                        axios.post(api.API_ENDPOINTS.tickets + '/poc-sketch', formData)
                            .then(response => {
                                this.getSingleTicket()
                                this.ticket.replies.unshift(response.data.chat)
                                this.$swal.mixin().fire({
                                    icon: 'success',
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 2000,
                                    title: response.data.message
                                })
                                this.form.message = ''
                                this.form.file = []
                                this.replyVisible = false

                                this.$refs.fileUploaded.reset()
                                this.$nextTick().then(()=>{
                                    this.$refs.problemForm.reset();
                                })

                            })
                    }
                })
            },
            closeTicket() {
                this.ticketLoading = true
                axios.put(api.API_ENDPOINTS.tickets + '/poc-sketch/' + this.$route.params.id + '/close')
                    .then(response => {
                        this.getSingleTicket()
                        this.$toast.success(response.data.message)
                    })
            }
        }
    }
</script>

<style scoped>
.title-div{
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title-div h3{
    font-size: 25px;
    color:#aa93a8;
}
.ticket-content{
    max-height: 60vh;
    overflow: auto;
    padding: 0 15px;
    margin-top: 15px;
}
.ticket-content .head-flex{
    display: flex;
    align-items: center;
}
.ticket-content .head-flex img{
    margin-right: 15px;
    border-radius: 50%;
    max-width: 30px;
}
.title-div p{
    font-size: 15px;
}
.title-div .ticket-opened{
    color: #fff;
    text-align: center;
    font-weight: 600;
}
.title-div .ticket-closed{
    color: #ea8196;
    text-align: right;
    font-weight: 600;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.flex{
    display: flex;
}
.ticket-reply .body{
    font-size: 14px;
}
.ticket-reply{
    margin-bottom: 15px;
}
 .ticket-agent .body{
    border: 1px solid #8c6984 !important;
}
 .ticket-agent .footer{
     background: #8c6984 !important;
 }
 .ticket-reply .footer{
     background: #6c757d;
     border-bottom-left-radius: 5px;
     border-bottom-right-radius: 5px;
     padding: 6px 20px;
     margin-top: -4px;
     display: flex;
     align-items: center;
     flex-wrap: wrap;
 }
 .ticket-reply .footer p, .ticket-reply .footer a{
     font-size: 12px;
     color: #fff;
 }
 .ticket-reply .footer a{
     font-weight: 600;
     margin: 0 5px;
     text-decoration: none;
 }
 .ticket-agent .head{
     background: #8c6984 !important;
 }
.ticket-reply .head{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: #6c757d;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 6px 20px;
}
.ticket-reply .head p{
    color: #fff;
}
.bold-text{
    font-weight: 600;
}
.ticket-reply .body{
    padding: 15px 20px;
    border: 1px solid #cdd2d7;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.toggle-reply{
    background: #545a6f;
    color: #fff;
    font-size: 14px;
    padding: 5px 20px;
    width: 100%;
}

/* FORM */
.form-group >>> label{
    font-size: 14px;
    margin: 0;
}
.form-group >>> input{
    font-size: 14px;
    margin-top: 5px;
}
.form-group >>> textarea{
    font-size: 14px;
    margin-top: 5px;
}
.background {
    background: linear-gradient(to bottom, #8c6984, #816e8b);
    color: #fff;
    border: 0;
    width: fit-content;
    min-width: 110px;
    display: block;
    border-radius: 3px;
    padding: 4.5px 15px;
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
}
.background:hover {
    background: linear-gradient(to bottom, #816e8b, #8c6984);
}
.opened-status{
    background: #49cda8;
}
.client-reply-status{
    background: #8c6984;
}
.agent-reply-status{
    background: #ffc107;
}
.closed-status{
    background: #ea8196;
}
</style>
